import request from "root/js/request";

const getAnalyticsPricesSubjects = async ({ product_id__in, wb_api_key_ids }) => {
  const response = await request({
    url: `/analytics/prices/subjects/`,
    method: "get",
    params: {
      product_id__in,
      wb_api_key_ids,
    },
  });
  return response.data;
};

export { getAnalyticsPricesSubjects };
